import getCacheKey from "@/vue/planning/logic/getCacheKey";
import responsesCache from "@/vue/planning/state/responsesCache";
import { getAvailRequestData } from "@/vue/planning/logic/getRequestData";
import { AvailabilitiesResponse } from "@/types/responses";
import * as _ from "lodash";
import { getUniqueId } from "@/vue/planning/logic/uniqueId";
import isHaveAvailability from "@/vue/planning/logic/isHaveAvailability";
import { checkIsSummerOrWinter } from "@/utils/utils";

const getAvailability = async (
	packCode: string,
	startDate: string,
	endDate: string,
	storeObj: any
): Promise<AvailabilitiesResponse | null> => {
	if (storeObj.state.datepickerStartDate) {
		const newSeason = checkIsSummerOrWinter(storeObj.state.datepickerStartDate);
		if (newSeason !== storeObj.state.season) {
			storeObj.state.season = newSeason;

			window.seasonManager.switchSeasonWithoutReloading();
		}
	}
	// try to extract cached response
	const cacheKey = getCacheKey(
		packCode,
		startDate,
		endDate,
		storeObj.state.season,
		storeObj.state.participants
	);
	const existingAvailabilities = responsesCache.value.getResponse(
		"availabilities",
		cacheKey
	);
	if (existingAvailabilities) return existingAvailabilities;

	// if no cached response - make a request
	const availPromise: Promise<AvailabilitiesResponse | null> = new Promise(
		async (resolve) => {
			const requestData = getAvailRequestData(
				storeObj.state,
				storeObj.getters,
				packCode
			);
			const avail_resp = await window.searchEngineService.getAvailabilities(
				requestData
			);

			if (!isHaveAvailability(avail_resp)) return resolve(null);

			avail_resp.prestations = avail_resp.prestations.map((prest: any) => {
				prest["id"] = getUniqueId(prest);
				// do not recompute pricePerPerson as in availabilities because IRESA already did the computation in response
				return prest;
			});

			const newMapObj = { ...storeObj.state.prestMaps.seAvailabilities };
			newMapObj[packCode] = {};

			if (Object.keys(avail_resp).length !== 0) {
				avail_resp["prestations"].forEach(
					(prest: any) => (newMapObj[packCode][prest.id] = prest)
				);
			}
			storeObj.state.prestMaps.seAvailabilities = newMapObj;

			responsesCache.value.setResponse("availabilities", cacheKey, avail_resp);
			responsesCache.value = _.cloneDeep(responsesCache.value);

			resolve(avail_resp);
		}
	);

	return availPromise;
};

export default getAvailability;
